import React from 'react';
import { useTranslation } from 'react-i18next';
import PreviewCard from '../PreviewCard';

interface RoomsStepProps {
  address: string;
  area: string;
  size: string;
  rooms: string;
  onSelectRooms: (value: string) => void;
  onNext: () => void;
}

const ROOM_OPTIONS = ['1', '2', '3', '4', '5+'];

// Selecting a room count both records the value and advances the flow, so the
// rooms screen needs no separate Next button (matching the Figma).
const RoomsStep = ({ address, area, size, rooms, onSelectRooms, onNext }: RoomsStepProps) => {
  const { t } = useTranslation();

  const roomsLabel = rooms ? t('newLandingPage.addMyPlace.publish.roomsValue', { rooms }) : '';

  return (
    <div className="amp-step amp-step--rooms">
      <PreviewCard address={address} area={area} size={size} rooms={roomsLabel} roomsPlaceholder />

      <div className="amp-step__body">
        <h2 className="amp-step__question">{t('newLandingPage.addMyPlace.rooms.question')}</h2>
        <span className="amp-field__label">{t('newLandingPage.addMyPlace.rooms.label')}</span>

        <div className="amp-pills amp-pills--grid">
          {ROOM_OPTIONS.map((option) => (
            <button
              key={option}
              type="button"
              className={`amp-pill amp-pill--square${rooms === option ? ' amp-pill--square-selected' : ''}`}
              onClick={() => onSelectRooms(option)}
            >
              {option}
            </button>
          ))}
        </div>
      </div>

      <div className="amp-step__footer">
        <button type="button" className={`amp-cta${!rooms ? ' amp-cta--hidden' : ''}`} onClick={onNext}>
          {t('newLandingPage.addMyPlace.building.next')}
        </button>
      </div>
    </div>
  );
};

export default RoomsStep;
